import React from 'react';

const InstallPrompt = ({ triggerInstall, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '80px', // Por encima de la BottomNavigationBar
      left: '50%',
      transform: 'translateX(-50%)',
      width: '90%',
      maxWidth: '450px',
      background: 'linear-gradient(135deg, #0d2035 0%, #071526 100%)',
      border: '1px solid rgba(197, 160, 89, 0.4)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.7), 0 0 15px rgba(197, 160, 89, 0.15)',
      borderRadius: '12px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      zIndex: 1100,
      backdropFilter: 'blur(10px)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '2rem' }}>⚓</span>
        <div>
          <h4 style={{
            margin: 0,
            fontFamily: "'Orbitron', sans-serif",
            fontSize: '0.85rem',
            color: '#c5a059',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}>Instalar Vortex App</h4>
          <p style={{
            margin: '4px 0 0',
            fontFamily: "'Inter', sans-serif",
            fontSize: '0.75rem',
            color: 'rgba(181, 200, 216, 0.85)',
          }}>Añade a tu inicio para estudiar sin distracciones.</p>
        </div>
      </div>
      
      <div style={{ display: 'flex', gap: '8px' }}>
        <button 
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'rgba(181, 200, 216, 0.5)',
            fontSize: '0.75rem',
            cursor: 'pointer',
            padding: '8px 12px',
            fontFamily: "'Orbitron', sans-serif",
            textTransform: 'uppercase',
          }}
        >
          Quizás luego
        </button>
        <button 
          onClick={triggerInstall}
          style={{
            background: '#c5a059',
            border: 'none',
            borderRadius: '6px',
            color: '#071526',
            fontWeight: '700',
            fontSize: '0.75rem',
            fontFamily: "'Orbitron', sans-serif",
            padding: '8px 14px',
            cursor: 'pointer',
            boxShadow: '0 0 10px rgba(197, 160, 89, 0.3)',
            transition: 'transform 0.1s ease',
            textTransform: 'uppercase',
          }}
          className="active-scale"
        >
          Instalar
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
